import Header from '../components/header/AdminHeader';
import { BaseUserInfo } from '../interface/BaseUserInfo';
import { useEffect, useState } from 'react';
import api from '../api/CallAdminApi';
import { Outlet, useLocation } from 'react-router-dom';
import { RootState } from '../../store';
import Loading from '../components/Loading';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { setGlobalDisplayName } from '../../store/displayNameReducer';
import { isEditingReport, isFixedFooterPage } from '../utils';

const BasePage: React.FunctionComponent = () => {
  const location = useLocation();
  const isLoading = useSelector((state: RootState) => state.loading.isLoading);
  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      const profile: BaseUserInfo = await api.getProfile();
      dispatch(setGlobalDisplayName(profile.name));
    })();
  }, []);

  useEffect(() => {
    // ページ更新（離脱）時にダイアログを表示（利用報告編集時のみ）
    const onBeforeunload = (e: any) => {
      if (isEditingReport(location)) {
        e.preventDefault();
        e.returnValue = '';
      }
    };

    // ページ更新（離脱）時のイベントを設定
    window.addEventListener('beforeunload', onBeforeunload, false);
    return () => {
      window.removeEventListener('beforeunload', onBeforeunload, false);
    };
  }, [location]);

  return (
    <>
      {isLoading && <Loading />}
      <Header />
      <div className={isFixedFooterPage(location) ? 'fixed-footer-page' : undefined}>
        <Outlet />
      </div>
    </>
  );
};

export default BasePage;
